import { useDeleteOteFpa } from "./api/deleteOteFpa";
import { Button } from "reactstrap";


const DeleteOteFpa = ({handleCloseModal, oteFpaId}: DeleteOteFpaProps)  => {
  
  const deleteOteFpaMutation = useDeleteOteFpa({ oteFpaId});
  const handleSubmit = async (): Promise<void> => {
    deleteOteFpaMutation.mutateAsync({ 
      oteFpaId: oteFpaId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε την Κατηγορία ΦΠΑ;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteOteFpaProps{
  oteFpaId: number;
  handleCloseModal: () => void;
}

export default DeleteOteFpa;